module.exports = __webpack_public_path__ + "img/2_ru.c99c6921.webp";